export function groupAccountsByCurrency(accounts = []) {
  const grouped = {};

  for (const account of accounts) {
    const currency = account?.currency || "UNKNOWN";

    if (!grouped[currency]) {
      grouped[currency] = {
        currency,
        walletBalance: 0,
        totalBalance: 0,
        accounts: [],
      };
    }

    grouped[currency].walletBalance += Number(account?.walletBalance || 0);
    grouped[currency].totalBalance += Number(account?.balance || 0);
    grouped[currency].accounts.push(account);
  }

  return Object.values(grouped).sort((a, b) =>
    String(a.currency).localeCompare(String(b.currency))
  );
}

export function buildManualTHIncomeTransactionRequest(payload, selectedAccount) {
  return {
    senderBankAccountId: payload.senderBankAccountId,
    receiverBankAccountId: selectedAccount?.id,
    transactionDate: payload.transactionDate,
    entryType: "MANUAL_INCOME",
    amount: payload.amount,
    senderRate: payload.senderRate ?? 1,
    receiverRate: payload.receiverRate ?? 1,
    fee: payload.fee ?? 0,
    description: payload.description || "",
  };
}

export function buildInternalTransactionRequest(payload, selectedAccount) {
  return {
    senderBankAccountId: selectedAccount.id,
    receiverBankAccountId: payload.receiverBankAccountId,
    transactionDate: payload.transactionDate,
    amount: payload.amount,
    senderRate: payload.senderRate ?? 1,
    receiverRate: payload.receiverRate ?? 1,
    fee: payload.fee ?? 0,
    description: payload.description || "",
  };
}